import { Flex, PaginationPerPageSelect, Select } from 'dash-ui';
import styled from 'styled-components';

export const FlexWraper = styled(Flex)`
  flex-direction: row;
  width: 100%;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
    width: 100%;
  }
`;

export const PaginationPerPageSelectWraper = styled(PaginationPerPageSelect)`
  width: 130px;
  margin: auto 4px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
    margin-top: 4px;
  }
`;

export const SelectWraper = styled(Select)`
  width: 144px;
  margin: auto 4px;
  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
    margin-top: 4px;
  }
`;
